import styled from "@emotion/styled";
import { Box, BoxProps } from "@mantine/core";
interface FormMainProps extends BoxProps {
  children: React.ReactNode;
  onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
}
export const FormWrapper = ({ children, onSubmit, ...etc }: FormMainProps) => {
  return (
    <Box h="auto" w={400} mx="auto" {...etc}>
      <Form onSubmit={onSubmit}>
        <FormFieldSet>{children}</FormFieldSet>
      </Form>
    </Box>
  );
};

const FormFieldSet = styled.fieldset`
  border: none;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const Form = styled.form`
  width: 100%;
  height: 100%;
`;
